import { ref } from 'vue';

export const notificationVisible = ref(false);
export const notificationIcon = ref('');

export const hideNotification = (): void => {
  notificationVisible.value = false;
  notificationIcon.value = '';
};

export const showNotification = (
  title: string,
  text: string,
  icon?: string
): void => {
  notificationVisible.value = true;

  if (icon) {
    notificationIcon.value = icon;
  }

  setTimeout(() => {
    const notificationTitle = document.getElementById('notificationTitle');
    const notificationText = document.getElementById('notificationText');
    if (notificationTitle) {
      notificationTitle.innerText = title;
    }
    if (notificationText) {
      notificationText.innerText = text;
    }
  }, 1);
};
